import { RelativeUrl } from "@adora/shared/utils/environment";
import fetcher from "@adora/shared/utils/fetch";
import { PresignedPostResponse } from "@adora/shared/types/presigned-post";

const uploadFile = async (file: File, brandId: number) => {
  const UploadUrlApi = RelativeUrl + "/ad_assets/upload_url";
  const { presigned_post: presignedPost } = await fetcher<PresignedPostResponse>(UploadUrlApi, {
    brand_id: brandId.toString()
  });
  if (!presignedPost) {
    throw "Invalid response from the server. Expected 200 status code.";
  }

  const formData = new FormData();
  Object.keys(presignedPost.fields).forEach((key) => {
    formData.append(key, presignedPost.fields[key]);
  });
  formData.append("file", file, file.name);

  const uploadRequestOptions = {
    method: "POST",
    body: formData
  };

  const response = await fetch(presignedPost.url, uploadRequestOptions);
  if (response.status > 204) {
    throw "Invalid response from the server. Expected 200 status code.";
  }

  const bucketName = presignedPost.url.split("/").pop();
  const baseKey = presignedPost.fields.key.replace("${filename}", "");
  const s3Path = `s3://${bucketName}/${baseKey}${file.name}`;

  return s3Path;
};

export default uploadFile;
